import { gql } from "@apollo/client";

export const GET_REFERRAL_FORM_BY_URL = gql`
  query GetReferralFormByUrl($url: String!) {
    getFormByUrl(url: $url) {
      id
      url
      createdBy
      service {
        id
        orgId
        name
        status
        alternateName
        description
        url
        email
        interpretationServices
        applicationProcess
        waitTime
        cost
        accreditations
        licenses
        subOpCategory
        opCategory
        requiredDocuments
        paymentsAccepted
        eligibilities
        fundings
        serviceAreas
        languages
        draft
        isPublished
        createdAt
        updatedAt
        overallCapacity
        currentlyServing
        autoScreen
        organization {
          name
        }
      }
      orgId
      formFields
      createdAt
      updatedAt
      status
      numberOfSubmissions
    }
  }
`;
